import {
  Dialog,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { Delete, Create } from "@mui/icons-material";
import ConfirmationModal from "../../../App/Components/Modals/ConfirmationModal";
import { callAPI } from "../../../App/Helpers/callApi";
import Signifier from "../../../App/Components/Signifier/Signifier";
import {
  deleteEventType,
  editEventType,
  getEventTypes,
} from "../EventTypesService";
import EditEventTypeModal from "./EditEventTypeModal";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  tableCell: {
    color: theme.palette.primary.copy,
  },
}));

export default function EventTypeTableCell({
  columns,
  element,
  index,
  setTableData,
}) {
  const classes = useStyles();
  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  const callDeleteEventType = () => {
    callAPI(
      deleteEventType(element.id),
      "Type Deleted",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getEventTypes(element.clientId).then((response) => {
        setTableData(response);
      });
    });
  };

  async function callEditEventType(json) {
    callAPI(
      editEventType(json),
      "Type Edited",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getEventTypes(element.clientId).then((response) => {
        setTableData(response);
      });
    });
  }

  function openModal(e) {
    e.preventDefault();
    setDeleteModal(true);
  }

  function openEditModal(e) {
    e.preventDefault();
    setEditModal(true);
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <TableRow
        hover
        className={index % 2 ? classes.rowCell : classes.rowCellOdd}
        key={index}
      >
        {columns.map((column, elementIndex) => (
          <TableCell
            align="left"
            key={elementIndex}
            className={classes.tableCell}
          >
            {column.label === "Delete" ? (
              <Tooltip title="Delete Featured Event">
                <IconButton onClick={(e) => openModal(e)} size="large">
                  <Delete />
                </IconButton>
              </Tooltip>
            ) : column.label === "Edit" ? (
              <Tooltip title="Edit Type Name">
                <IconButton onClick={(e) => openEditModal(e)} size="large">
                  <Create />
                </IconButton>
              </Tooltip>
            ) : (
              element[column.propName]
            )}
          </TableCell>
        ))}
      </TableRow>
      <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
        <ConfirmationModal
          question="Delete this event type?"
          func={() => callDeleteEventType()}
          closeModal={() => setDeleteModal(false)}
        />
      </Dialog>
      <Dialog open={editModal} onClose={() => setEditModal(false)}>
        <EditEventTypeModal
          openModal={setEditModal}
          typeName={element.name}
          typeId={element.id}
          clientId={element.clientId}
          func={callEditEventType}
        />
      </Dialog>
    </>
  );
}
